import { COLORS } from 'cleveron-web-components/utils';
import queryString from 'query-string';

export const timeToDaysHoursMinutes = (time, unit) => {
    const totalSeconds = parseInt(Math.floor(time / 1000), 10);
    let totalMinutes = parseInt(Math.floor(totalSeconds / 60), 10);
    if (unit === 's') {
        totalMinutes = parseInt(Math.floor(time / 60), 10);
    }
    const totalHours = parseInt(Math.floor(totalMinutes / 60), 10);
    const days = parseInt(Math.floor(totalHours / 24), 10);

    const minutes = parseInt(totalMinutes % 60, 10);
    const hours = parseInt(totalHours % 24, 10);

    return { days, hours, minutes };
};

export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${(bytes / k ** i).toLocaleString([], {
        maximumFractionDigits: dm,
        minimumFractionDigits: dm,
    })} ${sizes[i]}`;
}

export function toIdsString(array) {
    return array && array.length > 0 ? array.toString() : undefined;
}

export function toValue(argument) {
    return argument?.split?.(',').map(a => parseInt(a, 10)) || [];
}

export function searchParamsToQueryString({ size, page, ...params }) {
    return queryString.stringify({
        ...params,
        limit: size,
        page: Number.isFinite(page) ? page + 1 : undefined,
    });
}

export function searchFormToQueryString({ ...params }) {
    return queryString.stringify({
        ...Object.entries(params).reduce(
            (res, [key, value]) => ({
                ...res,
                [key]: (Array.isArray(value) ? toIdsString(value) : value) || undefined,
            }),
            {}
        ),
        page: undefined,
    });
}

export function toStringArray(argument) {
    return argument.split(',');
}

export function getTimeDifferenceInHours(start, end) {
    let delta = Math.abs(end - start) / 1000;
    const isNegative = start > end ? 0 : 1;
    return [['hours', 60 * 60]].reduce((acc, [key, value]) => {
        acc[key] = Math.floor(delta / value) * isNegative;
        delta -= acc[key] * isNegative * value;
        return acc;
    }, {});
}

export function countUniqueValuesForCharts(category) {
    return (
        category?.reduce((acc, curr) => {
            let statsCategory = curr;
            acc[0] = '';
            if (statsCategory === null || statsCategory === '') {
                statsCategory = 'noValue';
            }
            if (statsCategory in acc) {
                acc[statsCategory] += 1;
            } else {
                acc[statsCategory] = 1;
            }
            return acc;
        }, {}) || {}
    );
}

export function getColors(count, skip) {
    const extraColors = ['#CCE4F4', '#B3D6EF', '#99C9E9'];
    const colors = COLORS.reduce((acc, color, i) => [...acc, COLORS[i * 3]], []).slice(0, count);
    return [...extraColors.slice(0, skip), ...colors];
}
